module.exports = __webpack_public_path__ + "img/16022_100.38de806f.gif";